import React, {useEffect, useState} from "react";
import { useLocation } from "react-router-dom";
import bottonIcon from "assets/image/botton_menu.png";
import LinkTo from "components/LinkTo";
import AppIcons from "components/AppIcons/index";
import MenuLabel from './MenuLabel'
import NotificationAlert from '../BottomMenu/NotificationAlert/index';
import ProfileService from "services/profile/ProfileService";
import eventBus from "commons/utils/EventBus";
import { useHistory } from "react-router-dom";
import { TeamService } from "services";
import { useSelector } from "react-redux";
import { checkIsNavigatorActive } from "../../helpers/NavigatorHelper";
import { translate } from 'react-i18next';
import i18n from '../../i18n'

import {
  Container,
  IconContainer,
  ShadowContainer,
  IconWrapper,
  NotificationIconStyled
} from "./BottomMenu_style.js";
import './BottomMenu.scss'
import { changeS3UrlToCdn } from "hooks/useCdn";

const BottomMenu = ({
  color1,
  color2,
  hasBeebot,
  selected,
  teamVisualIdentity: {
    bot_image: botImage,
    custom_modules: customModules,
    white_label: whiteLabel,
  },
  t
}) => {
  const [customNameModules, setCustomNameModules] = useState([]);
  const [courses, setCourses] = useState(0);
  const [lightningTest, setLightningTest] = useState(0);
  const [show, setShow] = useState(true);
  const [doubleClickBlock, setDoubleClickBlock] = useState(true);
  const [timeoutId, setTimeoutId] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [useBeebotNavigatorFront, setUseBeebotNavigatorFront] = useState(false);
  const history = useHistory();
  const custom = useSelector(state => state.teamState.config);
  useEffect(() => {
    setCourseName()
    getNotificationData()
    setShowFooter()
    setDoubleClickBlock(true)
    eventBus.on("quizpopanswered", () => {
      setLightningTest(lightningTest - 1);
    });
    const getProfileInfo = async () => {
      const profileService = new ProfileService(history);
      const [
        profile,
        userGroups,
        poweraApps,
      ] = await Promise.all([
        profileService.getProfile(),
        profileService.getUserGroups(),
        TeamService.getPowerApps(),
      ])
      if (!profile?.user) return;
      const isNavigatorActive = checkIsNavigatorActive(poweraApps, userGroups);
      setUseBeebotNavigatorFront(isNavigatorActive);
      const { user } = profile;
      const powerappsList = { data: poweraApps };
      setUserProfile({ ...user, powerappsList, custom });
      const languageMap = {
        1: 'pt-BR',
        2: 'es',
        3: 'pt-PT',
        4: 'en',
        5: 'fr'
      };
      i18n.changeLanguage(languageMap[user.idiom_id]);
    }
    getProfileInfo()
  }, []);
  const refreshPage = (page) => {
    clearTimeout(timeoutId);
    const idTimeout = setTimeout(() => setDoubleClickBlock(false), 5000);
    setTimeoutId(idTimeout);
    if (doubleClickBlock) return;
    
    const userSelectedSameIcon = page === selected;

    setDoubleClickBlock(true);
    if (userSelectedSameIcon && !doubleClickBlock) return window.location.reload(false);
  }
  const setShowFooter = () => {

    eventBus.on("quizpopanswered", () => {
      setLightningTest(lightningTest - 1);
    });
  
  }
  const setCourseName = () => {
    if(customModules && customModules.length > 0) {
      const moduleNames = customModules.reduce((acc, module) => {
        return { ...acc, [module.module_id]: module.module_name };
      }, {});
      setCustomNameModules(moduleNames);
    }
  }
  const getNotificationData = async () => {
    const profile = new ProfileService(true)
    const dataNotifications = await profile.getNotifications()
    if (!dataNotifications?.courses?.[0] || !dataNotifications?.lightningTest?.[0]) {
      setCourses(0);
      setLightningTest(0);
      return;
    }
    setCourses(dataNotifications.courses[0].value);
    setLightningTest(dataNotifications.lightningTest[0].value);
  }
  const icon = ({
    click,
    icon,
    label,
    notificationAlert,
    pageName,
    to,
  }) => {
    const pageSelected = selected.split('/')[1]
    const isSelected = pageName.some(page => page === pageSelected)
    const color = isSelected ? color1 : color2
    const fontWeight = isSelected ? '500' : 'normal'
    return (
      <LinkTo onClick={click} to={to} className="menu-item">
        <IconContainer>
          <div className="menu-icon-container">
            <NotificationIconStyled>
              <NotificationAlert
                notification={notificationAlert}
              />
              <AppIcons icon={icon} color={color} size={28} />
            </NotificationIconStyled>
            <MenuLabel label={label} color={color} fontWeight={fontWeight}/>
          </div>
        </IconContainer>
      </LinkTo>
    );
  }
  const beebotIcon = () => {
    if (!hasBeebot) return false;
    const isWhiteLabel = parseInt(whiteLabel) === 1;
    const isDefaultImageBot = botImage.indexOf("BOT.png") !== -1;
    const beetBotClassName = isDefaultImageBot ? "beebotMenuWhiteLabelDefault" : 'beebotMenuWhiteLabel'
    return (
      <LinkTo onClick={() => refreshPage("/chat")} to={"/chat"} className="menu-item">
        <div className="menu-icon-container">
          <img
            src={changeS3UrlToCdn(isWhiteLabel ? botImage : bottonIcon)}
            alt="Logo" 
            className={isWhiteLabel ? beetBotClassName : "beebotMenuNoWhiteLabel"}
            style={{filter: ""}}
          />
        </div>
      </LinkTo>
    );
  }
  const getLabel = (maxLenghtLabel, nameCourse) => {
    return ((nameCourse).length > maxLenghtLabel) ? (((nameCourse).substring(0, maxLenghtLabel - 3)) + '...') : nameCourse
  }
  const feedIconParams = {
    click: () => refreshPage('/home'),
    icon: 'home',
    label: 'Feed',
    pageName: ['home', 'feed'],
    to: '/home',
  }
  const wikiIconParams = {
    click: () => refreshPage('/wiki'),
    icon: 'lightning',
    label: getLabel(11, customNameModules.wiki || 'Wiki'),
    pageName: ['wiki', 'postOpen'],
    to: '/wiki',
  }
  const lightningTestIconParams = {
    click: () => refreshPage("/quizpop"),
    icon: 'quizpop',
    label: getLabel(11, t('menu.lightningTest')),
    notificationAlert: lightningTest,
    pageName: ['quizpop'],
    to: "/quizpop",
  }
  const quizIconParams = {
    click: () => refreshPage("/quiz"),
    icon: 'quiz',
    label: getLabel(11, customNameModules.quiz || 'Quiz'),
    notificationAlert: courses,
    pageName: ['quiz'],
    to: "/quiz",
  }

  return (
    <Container show={show}>
      <ShadowContainer className="shadow2">
        <IconWrapper className="maxWidth">
          {icon(feedIconParams)}
          {icon(wikiIconParams)}
          {useBeebotNavigatorFront
            ? userProfile && <BeebotScript
              src={process.env.REACT_APP_BEEBOT_NAVIGATOR_FRONT_SRC}
              profile={userProfile}
              apiNode={process.env.REACT_APP_API_URL}
              setUserProfile={setUserProfile}
              wikiLabel={getLabel(11, customNameModules.wiki || 'Wiki')}
            />
            : beebotIcon()
          }
          {icon(lightningTestIconParams)}
          {icon(quizIconParams)}
        </IconWrapper>
      </ShadowContainer>
    </Container>
  );
}

const BeebotScript = ({src, profile, apiNode, setUserProfile, wikiLabel}) => {
  const location = useLocation();
  const idioms = [{
    id: "2",
    code: "es",
    name: "Espanhol",
    datatable_language: "Spanish",
    flag_code: "es",
  },{
    id: "5",
    code: "fr",
    name: "Francês",
    datatable_language: "French",
    flag_code: "fr",
  },{
    id: "4",
    code: "en",
    name: "Inglês (EUA)",
    datatable_language: "English",
    flag_code: "us",
  },{
    id: "1",
    code: "pt_br",
    name: "Português Brasil",
    datatable_language: "Portuguese-Brasil",
    flag_code: "br",
  },{
    id: "3",
    code: "pt_pt",
    name: "Português Portugal",
    datatable_language: "Portuguese-Brasil",
    flag_code: "pt",
  }]
  useEffect(() => {
    if (!src) return;
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = () => {
      if (window.beebotNavigator && typeof window.beebotNavigator.init === 'function') {
        window.beebotNavigator.init({
          apiNode,
          apiNodeCookieName: '@beedookey',
          device: 'mobile',
          navigator: src.replace('/init.js', ''),
          parentSelector: '#beebot-container',
          profile: {...profile, idioms},
          wiki: {
            name: wikiLabel,
            article: {
              pathname: window.location.pathname,
            },
          }
        });
      }
    };
    script.onerror = () => {
      // Script falhou (404, CORS, etc.) – evita crash; Beebot fica indisponível
    };
    document.body.appendChild(script);
  }, []);
  useEffect(() => {
    if (window.beebotNavigator && window.beebotNavigator.utils){
      if(window.beebotNavigator.utils.resendWikiInfo) {
        window.beebotNavigator.utils.resendWikiInfo(wikiLabel)
      }
      if(window.beebotNavigator.utils.updateInfo) {
        const userLanguage = i18n.language
        const languageMap = {
          'pt-BR': 1,
          'es': 2,
          'pt-PT': 3,
          'en': 4,
          'fr': 5
        };
        const idiom_id = languageMap[userLanguage] || 1
        if(idiom_id === profile.idiom_id) return;
        setUserProfile({...profile, idiom_id})
        const userProfile = {...profile, idioms, idiom_id}
        window.beebotNavigator.utils.updateInfo({profile: userProfile}, 'user')
      }
    }
  }, [location]);
  return (<div id="beebot-container" />);
};

export default translate()(BottomMenu);
